import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { Card } from '../../../../../components/card/card';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { Loader } from '../../../../../components/loader/loader';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Table } from '../../../../../features/table/table';
import { TableFilterInput } from '../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { TasksCreatePlannerModal } from '../tasks-create-planner-modal/tasks-create-planner-modal';
import { useTasksPlannerUtils } from '../use-task-planner-utils';
import s from './tasks-planner-table.module.css';

export const TasksPlannerTable = () => {
  const {
    isLoading,
    list,
    branches,
    t,
    getLocale,
    weekDays,
    staff,
    editableModal,
    setEditableModal,
    deleteScheduler,
    addQueryParams,
    getEmployees,
    getEmployeeNames,
    getDaysOfWeek,
    getSpecialDays,
    pagination,
  } = useTasksPlannerUtils();

  return (
    <Card className={s.feature}>
      {isLoading && <Loader />}
      <Table
        pagination={pagination}
        id="task-planner"
        columnSettings
        cols={{
          title: { label: t('Название') },
          branch: {
            label: t('Филиал'),
            filter: <TableFilterMultiSelect name="branch" options={branches} />,
          },
          employee: {
            label: t('Ответственный'),
            filter: <TableFilterInput name="employee" />,
          },
          startTime: { label: t('Время начала') },
          days: { label: t('Дни') },
          actions: { label: t('Действия') },
        }}
        rows={list?.map((item) => {
          const employees = getEmployees(staff, item.staff_ids);
          const employeeNames = getEmployeeNames(employees);
          const daysOfWeek = getDaysOfWeek(item.days_of_week, weekDays);
          const specDays = getSpecialDays(item.start_date);

          return {
            title: item.title,
            branch: getLocale(item.place_name),
            employee: employeeNames,
            startTime: item.start_time,
            days: item.is_regular ? daysOfWeek : specDays,
            actions: (
              <HasAccess service="task" permissions={['write']}>
                <div className={s.actions}>
                  <IconButton
                    tooltip={t('Редактировать')}
                    size="sm"
                    variant="secondary"
                    onClick={() => setEditableModal(item)}
                  >
                    <AiOutlineEdit />
                  </IconButton>
                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    onClick={() =>
                      addQueryParams({
                        deleteId: item.id.toString(),
                        deleteName: item.title,
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                </div>
              </HasAccess>
            ),
          };
        })}
      />

      <HasAccess service="task" permissions={['write']}>
        {editableModal && (
          <TasksCreatePlannerModal
            onClose={() => setEditableModal(undefined)}
            scheduler={editableModal}
          />
        )}
        <DeleteModal onSubmit={deleteScheduler} />
      </HasAccess>
    </Card>
  );
};
